import React from "react";
import { SBBox } from "modules/Commons";
import { SBNewTable } from "modules/Commons/SBDataDisplays/SBTable/SBNewTable";
import { IConfigCSVErrors } from "domain/Config/Models/IConfigCSVErrors";
import { useStyles } from "../style";
import { useDistributionOrderUploadErrorsHeader } from "./useDistributionOrderUploadErrorsHeader";

interface DistributionOrderUploaderHelperErrorProps {
	errors: IConfigCSVErrors[];
}

const DistributionOrderUploaderHelperError: React.FC<
	DistributionOrderUploaderHelperErrorProps
> = ({ errors }) => {
	const classes = useStyles();
	const { headers } = useDistributionOrderUploadErrorsHeader();

	return (
		<SBBox className={classes.errorsTableContainer}>
			<SBNewTable
				key={errors.length}
				startRows={errors}
				defaultColumns={headers}
				onClick={() => {}}
				title="errors"
				disableToolbar
				virtualize
				containerHeight={295}
			/>
		</SBBox>
	);
};

export default DistributionOrderUploaderHelperError;
